module.exports = __webpack_public_path__ + "img/mapa_en.1e17543c.jpg";